import type { NewFeedback } from "./schemas/feedback.js";

// The ONE builder of the POST /api/feedback body. What differs per surface is
// injected by the mount (surface, version, device tag, last screen); the shape
// and the "omit what is absent" rule are written once. Mobile's
// submitMobileFeedback and web's submitWebFeedback both go through it.

export type FeedbackEnvelope = {
  surface: NewFeedback["surface"];
  appVersion: string;
  device?: string;
  lastScreen?: string | null;
};

export function buildFeedbackBody(
  content: Pick<NewFeedback, "kind" | "body" | "attachment" | "fingerprint">,
  envelope: FeedbackEnvelope,
): NewFeedback {
  const { lastScreen, ...rest } = envelope;
  return {
    ...content,
    ...rest,
    ...(lastScreen ? { lastScreen } : {}),
  };
}
